// h5 tab bar 路由
export var MAIN_TAB_BAR = [{
  title: '首页',
  to: {
    path: '/home'
  },
  icon: 'icon-a-Property1home2',
  activeIcon: 'icon-a-Property1home1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671614746_pre$prod-ubq'
}, {
  title: '市场',
  to: {
    name: 'Market',
    path: '/auction/market'
  },
  icon: 'icon-a-Property1market2',
  activeIcon: 'icon-a-Property1market1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671614853_pre$prod-ubq'
}, {
  title: '发现',
  to: {
    name: 'FindIndex',
    path: '/find'
  },
  icon: 'icon-a-Property1found2',
  activeIcon: 'icon-a-Property1found1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671614920_pre$prod-ubq'
}, {
  title: '资产',
  to: {
    name: 'AccountIndex',
    path: '/account/index'
  },
  icon: 'icon-a-Property1me2',
  activeIcon: 'icon-a-Property1me1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671614936_pre$prod-ubq'
}];
// 品牌馆 tab bar 路由
export var BRAND_TAB_BAR = [{
  title: '主页',
  to: {
    // name: 'BrandDetails',
    path: '/brand/details'
  },
  icon: 'icon-erjizhuye',
  activeIcon: 'icon-erjizhuye-1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671688298_pre$prod-ubq'
}, {
  title: '市场',
  to: {
    name: 'BrandMarket',
    path: '/auction/brandMarket'
  },
  icon: 'icon-erjishichang',
  activeIcon: 'icon-erjishichang-1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671688312_pre$prod-ubq'
}, {
  title: '发现',
  to: {
    name: 'FindIndex',
    path: '/find'
  },
  icon: 'icon-erjifaxian',
  activeIcon: 'icon-erjifaxian-1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671688322_pre$prod-ubq'
}, {
  title: '我的',
  to: {
    name: 'AccountIndex',
    path: '/account/index'
  },
  icon: 'icon-erjiwode',
  activeIcon: 'icon-erjiwode-1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671688334_pre$prod-ubq'
}];